// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

export function Lightbulb({
  className,
  title = 'Lightbulb',
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      role="img"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 9.5C4.5 5.36 7.86 2 12 2C16.14 2 19.5 5.36 19.5 9.5C19.5 13.32 16.84 15.36 15.73 16H8.27C7.16 15.36 4.5 13.32 4.5 9.5ZM16 19V17H8V19H16ZM12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z"
        fill="currentColor"
      />
    </svg>
  );
}
